// extracted by mini-css-extract-plugin
export var chip = "_di-0";
export var filterDropdown = "_di-5";
export var filterItem = "_di-6";
export var icon = "_di-1";
export var removeButton = "_di-3";
export var removeIcon = "_di-4";
export var separator = "_di-2";